import { render, staticRenderFns } from "./ProfileStep3.vue?vue&type=template&id=4a34f92c&"
import script from "./ProfileStep3.vue?vue&type=script&lang=js&"
export * from "./ProfileStep3.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStep3.vue?vue&type=style&index=0&id=4a34f92c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports